import { createSlice } from "@reduxjs/toolkit";
import { fetchFilterList, fetchMasterList, fetchTilesData, updateTilesData } from "./DashboardAsyncThunks";
import {
  initialState,
  handleUpdateDepartment,
  handleUpdateSyncData,
  handleUpdateCustomizerFlag,
  handleFullFilledForFetchMasterList,
  handleFullfilledForFetchFilterList,
  handlePendingForFetchTilesData,
  handleFullfilledForFetchTilesData
} from "./DashboardReducers";

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    handleUpdateDepartment,
    handleUpdateSyncData,
    handleUpdateCustomizerFlag
  },
  extraReducers(builder) {
    builder
      .addCase(fetchMasterList.fulfilled, handleFullFilledForFetchMasterList)
      .addCase(fetchFilterList.fulfilled, handleFullfilledForFetchFilterList)
      .addCase(fetchTilesData.pending, handlePendingForFetchTilesData)
      .addCase(fetchTilesData.fulfilled, handleFullfilledForFetchTilesData)
      .addCase(updateTilesData.pending, handlePendingForFetchTilesData)
      .addCase(updateTilesData.fulfilled, handleFullfilledForFetchTilesData);
  }
});

export const {
  handleUpdateDepartment: setDepartment,
  handleUpdateSyncData: syncData,
  handleUpdateCustomizerFlag: setCustomizationFlag
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
